import React from 'react';
import BuildIcon from '@mui/icons-material/Build';
import SimpleLookupManagement, { LookupField } from './SimpleLookupManagement';

const fields: LookupField[] = [
  { key: 'name', label: 'Name', required: true, helperText: 'e.g. "Ground Rig - Standard Boom"' },
  { key: 'alias', label: 'Alias', helperText: 'Optional short label' },
  { key: 'sortIndex', label: 'Sort Index', type: 'number' },
];

const OperationMethodManagement: React.FC = () => (
  <SimpleLookupManagement
    title="Operation Method Management"
    icon={<BuildIcon />}
    apiPath="/api/operation-methods"
    fields={fields}
    entityLabel="Method"
  />
);

export default OperationMethodManagement;
